export const isTrackedOrderPath = (orderID: string | undefined, pathname: string) =>
  !!orderID && pathname.startsWith(`/order/${orderID}/paired-cost/`);

export const getPageKey = (orderID: string | undefined, pathname: string) => {
  if (!orderID) return pathname;
  return pathname.replace(new RegExp(`^.*/order/${orderID}/`), '');
};

export const getRouteHistoryEntry = (orderID: string | undefined, pathname: string) =>
  getPageKey(orderID, pathname);
